import { render } from "./ChallengeFlowItem.vue?vue&type=template&id=5aafb581&scoped=true"
import script from "./ChallengeFlowItem.vue?vue&type=script&lang=js"
export * from "./ChallengeFlowItem.vue?vue&type=script&lang=js"

import "@/css/components/challenge-flow-item.css?vue&type=style&index=0&id=5aafb581&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aafb581"]])

export default __exports__